import {Component} from 'react';
import firebase from 'firebase/app';


export default class BillDataModel extends Component {
  constructor(props){
    super(props);
    this.state = {
      billsValue: null,
      billsRef: null,
    }
  }

  componentDidMount() {
    console.log(this.props)
    let userKey = this.props.user.email.replace(/[^a-zA-Z0-9]/g, "");
    let billsRef = firebase.database().ref('userBills/' + userKey);
    this.setState( {billsRef: firebase.database().ref('userBills/' + userKey) })
    billsRef.on('value', (snapshot) => {
      let billsValue = snapshot.val();
      this.props.billDataCallback(billsValue);
    });
  }
  
  componentWillUnmount(){
    this.state.billsRef.off();
  }


  render(){
    return("");
  }
}